import { getLocale } from "../runtime";

const sv_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Sidan hittades inte`
};

const pagenotfound = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_pagenotfound(inputs)
	return "pageNotFound";
};

export { pagenotfound as "pageNotFound" };